import { render, staticRenderFns } from "./surface_post_being_showed.vue?vue&type=template&id=20038dab&scoped=true&"
import script from "./surface_post_being_showed.vue?vue&type=script&lang=js&"
export * from "./surface_post_being_showed.vue?vue&type=script&lang=js&"
import style0 from "./surface_post_being_showed.vue?vue&type=style&index=0&id=20038dab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20038dab",
  null
  
)

export default component.exports